export class CalendarEventReminderListDTO {

    type: number;

    unit: number;

    value: number;

}
